"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createAuthButton = _interopRequireDefault(require("./createAuthButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseButton(props) {
  var title = props.title,
      disabled = props.disabled,
      className = props.className,
      onClick = props.onClick;
  return _react.default.createElement("button", {
    className: className,
    type: "button",
    disabled: disabled,
    onClick: disabled ? null : onClick
  }, title);
}

BaseButton.propTypes = {
  disabled: _propTypes.default.bool,
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func.isRequired
};
BaseButton.defaultProps = {
  disabled: false,
  title: 'Connect Account',
  className: ''
};
var AuthButton = (0, _createAuthButton.default)(BaseButton);
var _default = AuthButton;
exports.default = _default;